export default __webpack_public_path__ + "static/media/cny-lucky-draw.2f0f621f.webp";